import { apiJson } from "@/services/api";

const state = {
  rolesDetalle: [],
};

const mutations = {
  setRolesDetalle(state, lista) {
    state.rolesDetalle = lista;
  },
};

const actions = {
  /** Roles con su número de usuarios y sus permisos (rutas del menú). */
  async consultarRolesDetalle({ commit }) {
    const res = await apiJson("GET", "/roles/detalle");
    commit("setRolesDetalle", res.data);
    return res.data;
  },
  /** Crea (sin id) o actualiza un rol. Para el Administrador se omiten los permisos: siempre tiene acceso total. */
  async guardarRol({ dispatch }, { id, nombre, permisos }) {
    try {
      if (id) {
        await apiJson("PUT", `/roles/${id}`, { nombre, ...(permisos && { permisos }) });
      } else {
        await apiJson("POST", "/roles", { nombre, permisos });
      }
    } catch (e) {
      throw { code: e.code || "Error PIMG-13", msg: e.msg || "No se pudo guardar el rol. Inténtalo más tarde." };
    }
    await Promise.all([
      dispatch("consultarRolesDetalle"),
      dispatch("autenticacion/consultarRoles", null, { root: true }),
    ]);
    await dispatch("autenticacion/cargarUsuarioActual", null, { root: true });
    dispatch("menu/actualizarMenuPorRol", null, { root: true });
  },
  async consultarUsuariosRol(_, id) {
    const res = await apiJson("GET", `/roles/${id}/usuarios`);
    return res.data;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
